import type { PropsWithChildren } from 'react'
import { CookieConsentBanner } from '@/components/cookie-consent-banner'
import { OrgLayout } from '@/components/org-layout'
import { Toaster } from '@/components/ui/sonner'
import { useFlash } from '@/hooks/use-flash'

/**
 * Wraps every page: org chrome where there's an org, flash toasts everywhere.
 *
 * The toasts deliberately sit outside OrgLayout rather than inside it.
 * OrgLayout returns children unwrapped when there's no `nav` shared prop —
 * every page reachable before sign-in — and those are exactly the pages
 * carrying flash worth seeing ("Invalid or expired invitation link.").
 *
 * CookieConsentBanner sits here too, for the same reason: it only renders
 * itself on pages without a `nav` prop, but needs to be mountable from
 * every page rather than duplicated per-page.
 */
export function AppShell({ children }: PropsWithChildren) {
  useFlash()

  return (
    <>
      <OrgLayout>{children}</OrgLayout>
      {/* No richColors: it injects Sonner's own palette and overrides the
          --popover/--border wiring below, so toasts would stop tracking the
          app's tokens. */}
      <Toaster position="top-center" />
      <CookieConsentBanner />
    </>
  )
}
